/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * MessageIcon Icon
 * @author Anuja Gaikwad
 * @file MessageIcon.jsx
 */

import React from 'react';
import { SvgIcon } from '@material-ui/core';

function MessageIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 18 17">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 0C16.5978 0 17.9037 1.24878 17.9949 2.82371L18 3V10C18 11.5978 16.7512 12.9037 15.1763 12.9949L15 13H7.85L4.762 16.631C4.564 16.864 4.283 16.984 4 16.984C3.771 16.984 3.54 16.905 3.352 16.745C3.16086 16.5821 3.03878 16.3546 3.0078 16.1078L3 15.983V13C1.40218 13 0.0963291 11.7512 0.00509216 10.1763L0 10V3C0 1.40218 1.24878 0.0963291 2.82371 0.00509216L3 0H15ZM15 1.75H3C2.35406 1.75 1.82062 2.24307 1.75647 2.87242L1.75 3V10C1.75 10.6459 2.24307 11.1794 2.87242 11.2435L3 11.25H4.75V13.944L7.041 11.25H15C15.6459 11.25 16.1794 10.7569 16.2435 10.1276L16.25 10V3C16.25 2.35406 15.7569 1.82062 15.1276 1.75647L15 1.75ZM9 5.25C9.69036 5.25 10.25 5.80964 10.25 6.5C10.25 7.19036 9.69036 7.75 9 7.75C8.30964 7.75 7.75 7.19036 7.75 6.5C7.75 5.80964 8.30964 5.25 9 5.25ZM5.25 5.25C5.94036 5.25 6.5 5.80964 6.5 6.5C6.5 7.19036 5.94036 7.75 5.25 7.75C4.55964 7.75 4 7.19036 4 6.5C4 5.80964 4.55964 5.25 5.25 5.25ZM12.75 5.25C13.4404 5.25 14 5.80964 14 6.5C14 7.19036 13.4404 7.75 12.75 7.75C12.0596 7.75 11.5 7.19036 11.5 6.5C11.5 5.80964 12.0596 5.25 12.75 5.25Z"
        fill="#171717"
      />
    </SvgIcon>
  );
}

export default MessageIcon;

